import axiosInstance from "../Axiosinstance";
import { ENDPOINTS } from "../Endpoints";

class MessagesService {
  async getConversations(params = {}) {
    const res = await axiosInstance.get(ENDPOINTS.MESSAGES.CONVERSATIONS, { params });
    return res.data;
  }

  async getConversationMessages(conversationId, params = {}) {
    const res = await axiosInstance.get(
      `${ENDPOINTS.MESSAGES.CONVERSATIONS}/${conversationId}`,
      { params }
    );
    return res.data;
  }

  async sendMessage(recipientId, text) {
    const res = await axiosInstance.post(ENDPOINTS.MESSAGES.SEND, { recipientId, text });
    return res.data;
  }

  async getUnreadCount() {
    const res = await axiosInstance.get(ENDPOINTS.MESSAGES.UNREAD_COUNT);
    return res.data;
  }

  async markAsRead(conversationId) {
    const res = await axiosInstance.patch(
      `${ENDPOINTS.MESSAGES.CONVERSATIONS}/${conversationId}/read`
    );
    return res.data;
  }
}

const messagesService = new MessagesService();
export default messagesService;
